<template>
  <div class="fin-screener">

    <fin-data-loader :resolver="fetchData" v-if="!$route.params.id">
      <template #content="{data}">
        <fin-screener-list
          v-model="screenerList"
          :create-screener="createScreener"
          :delete-screener="deleteScreener"
          :noData="noData"
          :update-screener-name="updateScreenerName"
          description="Durchsuche unsere umfangreichen Unternehmensdaten nach den besten Aktien für deine Strategie."
          title="Aktien-Screener"
          @edit="onEdit"
          @execute="onExecute"/>
      </template>
    </fin-data-loader>
    <router-view v-else/>
  </div>

</template>

<script>
import {finShareScreenerAPI, finUserAPI, finShareAPI} from '@/js/finAPI'
import {mapGetters} from 'vuex'
import FinScreenerList from '@/components/pages/finTools/finScreener/ScreenerList/index'
import FinDataLoader from '@/components/common/DataLoader/index'
import {EventBus} from '@/plugins/fincraft'

export default {
  name: 'fin-screener',
  components: {FinDataLoader, FinScreenerList},
  data() {
    return {
      screenerList: undefined,
      noData: 'Du hast noch keinen eigenen Aktien-Screener angelegt.'
    }
  },
  computed: mapGetters('auth', ['userId']),
  methods: {
    onEdit(screener) {
      this.$router.push({
        name: 'shareScreenerEdit',
        params: {id: screener.id}
      }).catch(err => {
        // ignore redundant navigation exception
      })
    },
    onExecute(screener) {
      this.$router.push({
        name: 'shareScreenerExecute',
        params: {id: screener.id}
      })
    },
    async fetchData() {
      this.screenerList = await finUserAPI.getShareScreeners()
    },
    async createScreener(name) {
      const hits = await finShareAPI.totalShares()
      return await finShareScreenerAPI.saveShareScreenerConfiguration(this.createNewScreenerObject(name,hits))
    },
    async updateScreenerName(screener, name) {
      await finShareScreenerAPI.renameShareScreenerConfiguration({
        id: screener.id,
        name: name
      })
      this.$set(screener, 'name', name) // TODO better @input of list
    },
    async deleteScreener(screener) {
      await finShareScreenerAPI.deleteShareScreenerConfiguration(screener).then(result => {
        this.$toasted.global.finToast({
          message: 'Dein Screener %name% wurde gelöscht.',
          placeholders: [{name: 'name', content: result.name}],
          type: 'success',
        })
      }).catch(error => {
        console.error("deleteScreener error", error)
        this.$toasted.global.finToast({
          message: 'Dein Screener %screenerName% konnte nicht gelöscht werden.',
          placeholders: [{name: "screenerName", content: screener.name}],
          type: 'error'
        })
      })
    },
    createNewScreenerObject(name, hits=0) {
      return {
        name: name,
        user: {
          id: this.userId
        },
        lastHits: hits,
        screenerConfigurationUserId: this.userId,
        region: {
          id: 'ALL',
          name: 'Welt',
          level: 0
        },
        sector: {
          id: 'ALL',
          name: 'ALL',
          level: 0
        },
        marketCapCategory: {
          id: 'ALL',
          name: 'ALL'
        },
        screenerConfigurationRegionId: 'ALL',
        screenerConfigurationSectorId: 'ALL',
        screenerConfigurationMarketCapCategoryId: 'ALL',
        filters: {
          items: []
        },
        valueFilters: {
          items: []
        }
      }
    }
  },
  mounted() {
    EventBus.$on('edit', this.onEdit)
  },
  beforeDestroy() {
    EventBus.$off('edit',
        this.onEdit
    )
  }
}

</script>
